import { getIconSize } from '../utils';

export const ImportPartsIcon = ({ size }: { size: string; }) => {
    const sizeNumber = getIconSize(size);

    return (
      <svg
        width={sizeNumber}
        height={sizeNumber}
        viewBox={`0 0 ${sizeNumber} ${sizeNumber}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0.75V10.5"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.75 7.5L11 10.5L14.25 7.5"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 23.25L1 17.25V8.25L11 14.5V23.25Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 17.25L11 23.25V14.5L21 8.25V17.25Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.99 4.5L21 8.25L11 14.5L1 8.25L7 4.5"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
}
